import {create} from "@/api/rest";

const support = {
  create: async (data) => await create('/support', data),
};

export default support;